module.exports = __webpack_public_path__ + "media/guanya quesito_2.5c3bf132.wav";